export const en = {
    styles: 'styles',
    tastes: 'tastes',
    sizes: 'sizes',
    frequency: 'frequency',
    addedToBag: 'Added to bag',
    addToBag: 'Add to bag',
    selectSize: 'Select size',
    selectStyle: 'Select style',
    optionsAvailable: 'Options available',
    selectSizeAndStyle: 'Select size & style',
    oneTimeShipment: '1 Time Shipment',
    autoDelivery: 'Auto Delivery',
    size: 'Size',
    viewAllSizes: 'View all sizes',
    viewAll: 'View all',
    was: 'Was',
    reviews: 'reviews',
    by: 'By',
    like: 'Like',
    currentPrice: 'Current price:',
    previousPrice: 'Previous price:',
    goToDetailPage: 'Go to detail page',
    freeShipping: 'Free Shipping',
    onlyXLeft: 'Only {{inventory}} item(s) left',
    outOf: 'out of',
    outOfStock: 'Out of stock',
    rating: 'Rating:',
    stars: 'stars'
};

export const fr = {
    styles: 'styles',
    tastes: 'tastes',
    sizes: 'sizes',
    frequency: 'frequency',
    addedToBag: 'Added to bag',
    addToBag: 'Add to bag',
    selectSize: 'Select size',
    selectStyle: 'Select style',
    optionsAvailable: 'Options available',
    selectSizeAndStyle: 'Select size & style',
    oneTimeShipment: '1 Time Shipment',
    autoDelivery: 'Auto Delivery',
    size: 'Size',
    viewAllSizes: 'View all sizes',
    viewAll: 'View all',
    was: 'Was',
    reviews: 'reviews',
    by: 'By',
    like: 'Comme',
    currentPrice: 'Prix actuel :',
    previousPrice: 'Prix précédent :',
    goToDetailPage: 'Go to detail page',
    freeShipping: 'Livraison Gratuite',
    onlyXLeft: 'Stock limité: seulement {{inventory}} unité(s)',
    outOf: 'sur',
    outOfStock: 'Stock épuisé',
    rating: 'Note :',
    stars: 'étoiles'
};
